import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=653cf58a&scoped=true&"
import script from "./Toggle.vue?vue&type=script&lang=js&"
export * from "./Toggle.vue?vue&type=script&lang=js&"
import style0 from "./Toggle.vue?vue&type=style&index=0&id=653cf58a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653cf58a",
  null
  
)

export default component.exports